// extracted by mini-css-extract-plugin
module.exports = {"summary":"MealsSumary_summary__1upWB"};